var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout',_vm._b({},'layout',{disabled: _vm.disabled},false),[_c('datepicker',_vm._b({on:{"selected":_vm.update}},'datepicker',{
			value: _vm.val,
			format: _vm.format,
			disabled: _vm.disabled,
			disabledDates: _vm.disabledDates,
			mondayFirst: true,
			placeholder: '...',
			inputClass: 'input',
		},false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }